export const GOOGLE_USER_CHANGED = "GOOGLE_USER_CHANGED";
export const GOOGLE_AUTH_INITIALIZED = "GOOGLE_AUTH_INITIALIZED";
export const SESSION_ACTIVE_SET = "SESSION_ACTIVE_SET";
export const SESSION_TOKEN = "SESSION_TOKEN";
export const SET_SESSION_ERROR = "SET_SESSION_ERROR";
export const SET_SUPPORT_CONTACT = "SET_SUPPORT_CONTACT";
export const SET_TEMP_TEACHER_SEARCH = "SET_TEMP_TEACHER_SEARCH";
export const SET_TEMP_STUDENT_SEARCH = "SET_TEMP_STUDENT_SEARCH";
export const SIGN_OUT = "SIGN_OUT";
